import React from 'react';
import Categorycontentmang from '../sections/sec-category-content-mangmenet';

const ContentmangementCategory = () => {
    return (
        <>
                <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
                <Categorycontentmang />
        </section>
        </>
      );
}
 
export default ContentmangementCategory;